import { Dispatch, SetStateAction } from "react";
import { useHistory } from "react-router-dom";
import { renderName } from "../../../../../libs/getInitialLetters";
import { IHoursManagementGrid, IProject } from "../models";

type SetDouberCardType = {
  userId: number;
  status: boolean;
};

interface ICardProps {
  item: IHoursManagementGrid;
  indexNumber?: number;
  ProjectsNameMuntipleCard: any;
  ProjectHoursBalance: any;
  setDoubleCard: Dispatch<SetStateAction<SetDouberCardType>>;
  setModalStatus: Dispatch<SetStateAction<any>>;
  handleSeeMoreClick: (p) => void;
}

export function Card({
  item = undefined,
  setDoubleCard,
  ProjectsNameMuntipleCard,
  ProjectHoursBalance,
  setModalStatus,
  handleSeeMoreClick,
}: ICardProps): JSX.Element {
  const history = useHistory();
  function handleDetailCard(id: number): void {
    setDoubleCard({ userId: id, status: true });
  }

  function handleDebitClick(): void {
    setModalStatus({
      user: item.userId,
      project: item?.projects[0] || item?.projects,
    });
  }

  return (
    <div className="card-hours-management-user font-roboto bold">
      <div className="header-card-hours-management bg-primary center row flex between">
        <span className="limit-10-char">{item?.userName}</span>
        {item?.imageUrl ? (
          <img src={item?.imageUrl} className="image-card-hours-management center" />
        ) : (
          <span className="image-card-hours-management center">{renderName(item?.userName)}</span>
        )}
      </div>

      <div className="body-card-hours-management column center around">
        <ProjectsNameMuntipleCard />
        <ProjectHoursBalance />
      </div>

      <div className="btn-card-hours-management flex center">
        {item?.projects?.length > 1 ? (
          <button onClick={() => handleDetailCard(item?.userId)} className="btn bg-secondary">
            Ver Mais
          </button>
        ) : (
          <>
            <button onClick={() => handleSeeMoreClick(item)} className="btn bg-secondary">
              Ver Mais
            </button>
            <button onClick={handleDebitClick} className="btn bg-primary">
              Debitar
            </button>
          </>
        )}
      </div>
    </div>
  );
}
